import { FC, useState, useEffect, useCallback } from 'react';
import commonModalClass from '../../assets/scss/CommonModal.module.scss';
import { UpdateMessageModalViewType } from '../../types/view/MessageModalViewType';
import { CommonModal } from '../CommonModal';
import { BottomButton } from '../ModalItem/BottomButton';
import { postMessageGtag } from '../../utils/trackClick';

export const AfterUpdateMessageModal: FC<{
  active: boolean;
  closeFunc: () => void;
  updateMessageModal: UpdateMessageModalViewType | null;
  showNewOrderModal?: () => void;
  closeWithoutReload?: () => void;
}> = ({ active, closeFunc, updateMessageModal, showNewOrderModal, closeWithoutReload }) => {
  const [content, setContent] = useState<JSX.Element>(<></>);

  const handleClose = useCallback(() => {
    closeFunc();
  }, [closeFunc]);

  const handleOrderClick = useCallback(() => {
    postMessageGtag('click_modal_open_OrderNow_BoxChange', 'detailProducts');

    if (closeWithoutReload) {
      closeWithoutReload(); // リロードなしで閉じる
    }
    if (showNewOrderModal) {
      showNewOrderModal();
    }
  }, [closeWithoutReload, showNewOrderModal]);

  useEffect(() => {
    if (!updateMessageModal) return;
    setContent(
      <>
        <div
          className={
            updateMessageModal.isSuccess
              ? `${commonModalClass.title} ${
                  updateMessageModal.showOrderLink && showNewOrderModal
                    ? commonModalClass.withOrderLink
                    : ''
                }`
              : `${commonModalClass.errorTitle}`
          }
        >
          {updateMessageModal.isSuccess ? '更新が完了しました。' : 'エラー'}
        </div>
        {!updateMessageModal.isSuccess && (
          <div className={commonModalClass.detail}>
            <p>更新できませんでした。</p>
            <p>もう一度お試しください。</p>
          </div>
        )}
        <div
          className={`${commonModalClass.btnContainer} ${
            updateMessageModal.isSuccess && updateMessageModal.showOrderLink && showNewOrderModal
              ? commonModalClass.withOrderLink
              : ''
          }`}
        >
          <BottomButton
            buttonTitle="閉じる"
            clickFunc={handleClose}
          />
        </div>
        {updateMessageModal.isSuccess && updateMessageModal.showOrderLink && showNewOrderModal && (
          <>
            <div className={commonModalClass.orderLink}>
              <button onClick={handleOrderClick}>すぐに商品が必要ですか？</button>
              <span>（2日以内に発送します）</span>
            </div>
          </>
        )}
      </>
    );
  }, [updateMessageModal, handleClose, handleOrderClick, showNewOrderModal]);

  return (
    <CommonModal
      active={active}
      closeFunc={closeFunc}
    >
      {content}
    </CommonModal>
  );
};
